
const ExportRunsheetDialogErrorView = ({
    error,
    onTryAgainClick,
}) => {
    
    return (<>
        
        <h5 className="mb-6 text-center">
            Export Failed
        </h5>
        
        <div className="flex flex-col justify-center items-center text-center">
            <p className="w-[400px]">{error}</p>
        </div>
        
        <div className="flex justify-center modal-footer">
            <button
                className="w-auto mt-4 btn btn-primary"
                onClick={onTryAgainClick}>
                Try Again
            </button>
        </div>
    </>)
    
}

export default ExportRunsheetDialogErrorView
